import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { RequireAuth } from './components/auth/RequireAuth';
import { HomePage } from './pages/HomePage';
import './App.css';

const ItemPage = React.lazy(() => import('./pages/ItemPage').then((m) => ({ default: m.ItemPage })));
const DealPage = React.lazy(() => import('./pages/DealPage').then((m) => ({ default: m.DealPage })));
const SignInPage = React.lazy(() => import('./pages/SignInPage').then((m) => ({ default: m.SignInPage })));
const SignUpPage = React.lazy(() => import('./pages/SignUpPage').then((m) => ({ default: m.SignUpPage })));
const CheckoutPage = React.lazy(() => import('./pages/CheckoutPage').then((m) => ({ default: m.CheckoutPage })));
const AccountLayoutPage = React.lazy(() =>
  import('./pages/AccountLayoutPage').then((m) => ({ default: m.AccountLayoutPage }))
);
const AccountOrdersPage = React.lazy(() =>
  import('./pages/AccountOrdersPage').then((m) => ({ default: m.AccountOrdersPage }))
);
const AccountUsersPage = React.lazy(() =>
  import('./pages/AccountUsersPage').then((m) => ({ default: m.AccountUsersPage }))
);
const AccountMenuConfigPage = React.lazy(() =>
  import('./pages/AccountMenuConfigPage').then((m) => ({ default: m.AccountMenuConfigPage }))
);
const AccountDiscountCodesPage = React.lazy(() =>
  import('./pages/AccountDiscountCodesPage').then((m) => ({ default: m.AccountDiscountCodesPage }))
);
const AccountFinancePage = React.lazy(() =>
  import('./pages/AccountFinancePage').then((m) => ({ default: m.AccountFinancePage }))
);
const AccountReportingPage = React.lazy(() =>
  import('./pages/AccountReportingPage').then((m) => ({ default: m.AccountReportingPage }))
);
const TermsPage = React.lazy(() => import('./pages/TermsPage').then((m) => ({ default: m.TermsPage })));
const PrivacyPage = React.lazy(() => import('./pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage })));
const CookiesPage = React.lazy(() => import('./pages/CookiesPage').then((m) => ({ default: m.CookiesPage })));

function RouteFallback() {
  return (
    <div className="container chunkzters-container py-5 text-center">
      <div className="spinner-border text-secondary" role="status" aria-label="Loading page" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="/test-menu" element={<HomePage testMode />} />
        <Route path="/item/:id" element={<ItemPage />} />
        <Route path="/test-menu/item/:id" element={<ItemPage testMode />} />
        <Route path="/deal/:id" element={<DealPage bundleType="deal" />} />
        <Route path="/test-menu/deal/:id" element={<DealPage bundleType="deal" testMode />} />
        <Route path="/munch-box/:id" element={<DealPage bundleType="munch_box" />} />
        <Route path="/test-menu/munch-box/:id" element={<DealPage bundleType="munch_box" testMode />} />
        <Route path="/cart" element={<Navigate to="/" replace />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/account" element={<AccountLayoutPage />}>
            <Route index element={<Navigate to="/account/orders" replace />} />
            <Route path="orders" element={<AccountOrdersPage />} />
            <Route element={<RequireAuth allow={['admin']} />}>
              <Route path="users" element={<AccountUsersPage />} />
              <Route path="menu" element={<AccountMenuConfigPage />} />
              <Route path="discount-codes" element={<AccountDiscountCodesPage />} />
              <Route path="finance" element={<AccountFinancePage />} />
              <Route path="reporting" element={<AccountReportingPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </Suspense>
  );
}
